import occInstance from '@/api/instances/occ';

const rootUrl = '/users';
const UserOccApi = {
  async fetchUserProfile() {
    const url = `${rootUrl}/current`;
    const {data: userProfile} = await occInstance.get(url, {params: {fields: 'FULL'}});
    return userProfile;
  },
  async patchUserProfile(params) {
    const url = `${rootUrl}/current`;
    const {data: updatedUserProfile} = await occInstance.patch(url, params);
    return updatedUserProfile;
  },
  async fetchGenderList() {
    const url = `enums/customergender`;
    const {data: userGenderList} = await occInstance.get(url);
    return userGenderList;
  },
  async getUserCompetency(userId) {
    const url = `users/${userId}/competency`;
    const {data: userCompetency} = await occInstance.get(url);
    return userCompetency;
  },
};

export default UserOccApi;
